import React from "react";
import Modal from "../../../../components/general/Modal";
import {
  Container,
  FlowName,
  Footer,
  SubTitle,
  Title,
  DivIcon,
} from "./styles";
import Button from "../../../../components/general/Button";
import Close from "../../../../assets/icons/Close";

//? Exclude Flow Model modal:
//isOpen -> Controlador se o modal está aberto ou não
//onClose -> Função executada ao cancelar/fechar/clicar fora do modal
//onConfirm -> Função executada ao confirmar no modal
//selector -> Local onde o modal sera renderizado(root -> Toda a tela)
//className -> nodrag = modal não pode ser movido
//flowName -> Nome renderizado na tela

const ExcludeModal = ({
  isOpen,
  onClose,
  onConfirm,
  selector,
  className,
  flowName,
  tipe = "Ativo",
}) => {
  return (
    <Modal
      isOpen={isOpen}
      selector={selector}
      className={className}
      flowName={flowName}
      onClose={onClose}
    >
      <Container>
        <Title>Excluir fluxo </Title>
        <SubTitle>Deseja seguir com a exclusão do Fluxo {tipe}?</SubTitle>
        <FlowName>{flowName}</FlowName>
        <Footer>
          <Button
            outline
            content="Cancelar"
            width={"11.3125rem"}
            height={"2.625rem"}
            onClick={onClose}
          />
          <Button
            content="Sim, excluir"
            width={"11.3125rem"}
            height={"2.625rem"}
            onClick={onConfirm}
          />
        </Footer>
        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>
      </Container>
    </Modal>
  );
};

export default ExcludeModal;
